import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { UserPreferences } from 'crono-fe-common/types/userPreferences';
import { invalidateListQueries } from '../lists/useCreateList';

type PatchUserPreferencesVars = UserPreferences;

export default function usePatchUserPreferences() {
  const queryClient = useQueryClient();

  const patchUserPreferences = (userPreferences: PatchUserPreferencesVars) => {
    const request: Request = {
      url: ENDPOINTS.user.preferences,
      config: {
        method: 'patch',
        data: userPreferences,
      },
    };

    return client(request);
  };

  return useMutation<Response<null>, CronoError, PatchUserPreferencesVars>(
    patchUserPreferences,
    {
      onSettled: async (_r, _e, params) => {
        if (params.openListsIds) {
          await queryClient.invalidateQueries([ENDPOINTS.list.search]);
        }
        if (params.automaticTaskLimit || params.hasSalesNav) {
          await queryClient.invalidateQueries([
            ENDPOINTS.task.linkedin.quantity,
          ]);
        }
        if (params.openListsIds) {
          await invalidateListQueries(queryClient);
        }
      },
      meta: {
        silentError: true,
      },
    },
  );
}
